<template>
    <transition name="slide-fade">
        <div class="alert-desc-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content rounded-25">
                <div class="bg-white w-full content-wrapper p-4">
                    <div class="absolute right-6 top-3 cursor-pointer" @click="clickOk()">
                        <img class="w-4" src="../../../../assets/icon/ic-close.png" />
                    </div>
                    <div class="text-tc-blue-1 text-center text-22 font-bold pt-3 pb-4" v-html="title"></div>
                    <div class="text-center text-20 text-tc-gray-3 pb-2.5" v-html="message"></div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "AlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .alert-desc-modal {
        @extend %modal;
    }
    hr{
        margin-bottom: 8px !important;
        margin-top: 8px !important;
    }
</style>
